module.exports = __webpack_public_path__ + "img/hebei.4eb74559.png";